import { useEffect, useState } from "react";
import Toaster from "../../Components/Toaster";
import TokenService from "../../Services/Token.service";
import { UserService } from "../../Services/User.service";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Helmet } from "react-helmet";
import Loader from "../../Components/Loader";
import { Accordion, FormCheck } from "react-bootstrap";
const AVAILABLE_ALERT_TYPES = ["sms", "email"];
function EmailSmsAlerts() {

    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [initialValues, setInitialValues] = useState({});
    const [alerts, setAlerts] = useState({});
    const [validationSchema, setValidationSchema] = useState();
    const [loading, setLoading] = useState(false);
    const [userRoles, setUserRoles] = useState(TokenService.getUserRoles());

    useEffect(() => { 
        fetchAlerts();
    }, []); 

    const fetchAlerts = async () => {

        setLoading(true);

        try {
            const alertData = await UserService.userAlerts(TokenService.getUserId());
            if(alertData.success) {
                const initialValues = alertData.alerts.reduce((acc, alert) => {
                    AVAILABLE_ALERT_TYPES.map((alertType) => {
                    const key = `alert_${alert.id}_${alertType}`;

                    const userAlert = alert.user_alerts?.[0]; // because API returns at most 1 entry per alert

                    if (!userAlert) {
                        acc[key] = false;
                        return;
                    }

                    const type = userAlert.alert_type;

                    if (type === "both") {
                        acc[key] = true; // both email and sms are true
                    } 
                    else if (type === alertType) {
                        acc[key] = true;
                    } 
                    else {
                        acc[key] = false;
                    }
                });

                return acc;
                }, {});
                
                setInitialValues(initialValues);
                

               const validationSchema = Yup.object().shape(
                    alertData.alerts.reduce((schemaAcc, alert) => {
                        const smsField = `alert_${alert.id}_sms`;
                        const emailField = `alert_${alert.id}_email`;

                        schemaAcc[smsField] = Yup.boolean();
                        schemaAcc[emailField] = Yup.boolean();

                        schemaAcc[`alert_group_${alert.id}`] = Yup.object()
                            .test(
                                `alert-methods-required-${alert.id}`,
                                "Please select at least one communication method for donation opportunity available.",
                                function () {
                                    const sms = this.parent[smsField];
                                    const email = this.parent[emailField];
                                    return sms || email; // ✅ both false → error
                                }
                            );

                        return schemaAcc;
                    }, {})
                );

                setValidationSchema(validationSchema);
                setAlerts(alertData.alerts);   
                setLoading(false);                    

            } else {    
                setInitialValues({}); 
                setValidationSchema({});
                setAlerts({});           
                setToastMessage(alertData.message);
                setToastVariant('error');
                setLoading(false);        
            }
        } catch (error) {
            setInitialValues({}); 
            setValidationSchema({});
            setAlerts({});   
            setLoading(false);        
            console.error("Error fetching sample types", error);
        }
    }
   
    const handleSubmit = async (values) => {
        setLoading(true); 
        // let params = {
        //     user_id: 
        // };

        // const alertData = {
        //     alerts: Object.keys(values).reduce((acc, key) => {
        //       const alertId = key.split('_')[1]; 
        //       acc[alertId] = values[key] == 'yes' ? ['email'] : []; 
        //       return acc;
        //     }, {})
        // };
         const payload = {
            user_id: TokenService.getUserId(),
            alerts: transformAlertPayload(values)
        };
        try {           
            const data = await UserService.updateAlerts(payload);           
            if (!data.success) {
                let message = '';
                if (typeof data.message === 'object' && data.message !== null) {
                    message = Object.values(data.message).flat().join(', '); 
                } else if (Array.isArray(data.message)) {
                    message = data.message.join(', ');
                } else {
                    message = data.message || 'An unknown error occurred.';
                }
                setToastMessage(message);
                setToastVariant('error');
            } else {
                setToastMessage(data.message);
                setToastVariant('success');
            }
        } catch (error) {
            console.log("error", error);
            setToastMessage('Failed to update.');
            setToastVariant('error');
        } finally {
            setLoading(false);
            setShowToast(true);
        }
       
    };
    const transformAlertPayload = (values) => {
    const alertsPayload = {};

    Object.keys(values).forEach((key) => {
        if (key.startsWith("alert_")) {
        const [_, alertId, type] = key.split("_"); // alert_1_sms → ["alert", "1", "sms"]

        if (values[key] === true) {
            if (!alertsPayload[alertId]) {
            alertsPayload[alertId] = [];
            }
            alertsPayload[alertId].push(type);
        }
        }
    });

    return alertsPayload;
    };

    return (
        <>
            <Loader loading={loading} />

            <Helmet>
                <title>DonorX | Email Alerts</title>
            </Helmet>

            <div className="el-middle-wrapper">
                <h2 className="el-title">Email Alerts</h2>            
                
                <div className="">    
                    <>  
                        <div className="el-bg-table el-super-admin mt-3">
                             {(typeof userRoles != 'undefined' && !userRoles.includes("Donor") &&
                             <>
                               <p> No content is available at the moment. Please complete your profile settings and try again.</p>
                             </>
                             )}
                            {(typeof userRoles != 'undefined' && userRoles.includes("Donor") && 
                            <>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                validateOnBlur={false}
                                validateOnChange={true}
                                onSubmit={handleSubmit}
                                enableReinitialize={true} // Enable reinitialization when initialValues change
                            >
                                {({ values, setFieldValue, setFieldTouched, errors, touched }) => (
                                    <Form>
                                         <Accordion className="email-sms-alerts" alwaysOpen defaultActiveKey={["0"]} flush>

                                             <Accordion.Item eventKey="0">
                                                <Accordion.Header className="cursor-pointer">

                                                     {(typeof userRoles != 'undefined' && userRoles.includes("Donor") && 
                                                        <div className="row">
                                                            {/* <label>For Donors. Notify me when:</label> */}
                                                            <h3>Notify Me When</h3>
                                                        </div>
                                                    )}

                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <container className="el-property-details-card-content">
                                                        <div>
                                                               {(typeof userRoles != 'undefined' && userRoles.includes("Donor") && 
                                                                    <div>
                                                                        {/* <label>For Donors. Notify me when:</label> */}
                                                                        <label className="mt-2">If you are being matched with donation opportunities, at least one communication method is required</label>
                                                                        
                                                                        {(alerts && Array.isArray(alerts) ? alerts : []).map((alert) => (
                                                                            <div className="row mt-3 col-xl-12 radio-wrapper" key={alert.id}>
                                                                                <label className="form-label-check">
                                                                                    {alert.title}
                                                                                </label>
                                                                                <div className="d-flex mt-3">  
                                                                                    {AVAILABLE_ALERT_TYPES.map((alertType) => {
                                                                                        const fieldName = `alert_${alert.id}_${alertType}`;
                                                                                        const isSelected = values[fieldName] ?? false;

                                                                                        return (
                                                                                            <FormCheck
                                                                                                key={alertType}
                                                                                                type="switch"
                                                                                                id={fieldName}
                                                                                                label={alertType.toUpperCase()}
                                                                                                checked={isSelected}
                                                                                                onChange={(e) => {setFieldValue(fieldName, e.target.checked)}}
                                                                                                className="me-4"
                                                                                            />
                                                                                        );
                                                                                    })}

                                                                                    {/* {['yes', 'no'].map((alertType) => {               
                                                                                                                            
                                                                                        const isSelected = values[`alert_${alert.id}`]?.includes(alertType);
                                                                                        return (
                                                                                            <div className="form-check" key={alertType}>
                                                                                                <Field
                                                                                                    type="radio"
                                                                                                    id={`email-alert-${alertType}`}
                                                                                                    name={`alert_${alert.id}`}
                                                                                                    value={alertType}
                                                                                                    className="form-check-input radio-pointer"
                                                                                                    checked={!!isSelected}
                                                                                                />
                                                                                                <label htmlFor={`email-alert-${alertType}`} className="form-check-label ms-2 radio-pointer">
                                                                                                    {alertType.charAt(0).toUpperCase() + alertType.slice(1)}
                                                                                                </label>
                                                                                            </div>
                                                                                        );
                                                                                    })} */}
                                                                                </div>
                                                                                <div  className="text-danger mt-1">
                                                                                {(
                                                                                    touched[`alert_${alert.id}_sms`] ||
                                                                                    touched[`alert_${alert.id}_email`]
                                                                                ) && errors[`alert_group_${alert.id}`] && (
                                                                                    <div className="text-danger mt-2">
                                                                                        {errors[`alert_group_${alert.id}`]}
                                                                                    </div>
                                                                                )}

                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                        <div className="d-flex align-items-center mt-4">
                                                                            <button type="submit" className="el-main-button me-3"> <span>Save Changes</span> </button>
                                                                        </div>   
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </container>
                                                </Accordion.Body>
                                                
                                             </Accordion.Item>
                                         </Accordion>
                                       
                                     

                                        
                                        {/* <div className="mt-5">
                                            {JSON.stringify(values)}
                                        </div>
                                              <div className="mt-5">
                                            {JSON.stringify(errors)}
                                        </div> */}
                                    </Form>
                                   
                                )}
                            </Formik>

                            </>
                            )}
                        </div>
                    </>
                </div>
            </div>            
            
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </>
    );
}

export default EmailSmsAlerts;